import { render, staticRenderFns } from "./NossaHistoria.vue?vue&type=template&id=c50a6eae&scoped=true&lang=pug"
import script from "./NossaHistoria.vue?vue&type=script&lang=js"
export * from "./NossaHistoria.vue?vue&type=script&lang=js"
import style0 from "./NossaHistoria.styl?vue&type=style&index=0&id=c50a6eae&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50a6eae",
  null
  
)

export default component.exports